import Image from 'next/image';
import styles from './nft-experience.module.css';
import { Container } from '../../components';
import NFTDivided from './nft-divided';

import nftDecktopImage1 from '../../public/nft/experience/nft-decktop-1.jpg';
import nftDecktopImage2 from '../../public/nft/experience/nft-decktop-2.jpg';
import nftMobileImage1 from '../../public/nft/experience/nft-mobile-1.jpg';
import nftMobileImage2 from '../../public/nft/experience/nft-mobile-2.jpg';

import multple1 from '../../public/nft/experience/multple-1.png';
import multple2 from '../../public/nft/experience/multple-2.png';
import multple3 from '../../public/nft/experience/multple-3.png';

import multple4 from '../../public/nft/experience/multple-4.png';
import multple5 from '../../public/nft/experience/multple-5.png';
import multple6 from '../../public/nft/experience/multple-6.png';

export default function NFTExperience() {
  return (
    <div>
      <Container variant="container_medium">
        <NFTDivided />
        <div className={styles.steps}>
          <h3 className={styles.stepsTitle}>
            Essential Points to Consider When Creating an NFT Marketplace
          </h3>
          <p className={styles.stepsText}>
            If you are seriously thinking about creating an NFT marketplace, you
            should study the basics and technical details. Since NFT technology
            is quite new and is only gaining momentum, you should be aware of
            all the details.
          </p>
          <h3 className={styles.stepsTitleSecond}>
            How to make an NFT marketplace step by step
          </h3>
          <p className={styles.stepsText}>
            Let us write down the following steps, which are important to know,
            since the development of an NFT marketplace is a complex and lengthy
            process.
          </p>
          <ul className={styles.stepsList}>
            <li className={styles.stepsListItme}>
              <b>Step 1.</b> Determine the scope and category in which you will
              create an NFT marketplace. It can be a site about works of art,
              make an NFT marketplace with quests and bonuses, or a platform in
              which you will communicate and receive requests from users.
            </li>

            <li className={styles.stepsListItme}>
              <b>Step 2.</b> Select a development company that can create an NFT
              trading platform. You need a team of experienced professionals in
              different industries. Outsourcing or fulfillment companies can
              help you.
            </li>

            <li className={styles.stepsListItme}>
              <b>Step 3.</b> Define the UI/UX design with the design team for
              the future platform. Quality design is an important part of
              building an NFT marketplace, it is the first thing that users take
              into account.
            </li>

            <li className={styles.stepsListItme}>
              <b>Step 4.</b> Monitor the development of your NFT marketplace at
              the stage of frontend and backend.
            </li>

            <li className={styles.stepsListItme}>
              <b>Step 5.</b> Test and fix issues of the developed NFT platform.
            </li>

            <li className={styles.stepsListItme}>
              <b>Step 6.</b> Release your own NFT marketplace and enjoy winning.
            </li>
          </ul>
        </div>
        <NFTDivided />
        <div className={styles.experience}>
          <h3 className={styles.experienceTitle}>
            How to Make an NFT Marketplace: Mavinx Experience
          </h3>
          <p className={styles.experienceText}>
            For more than five years, our MavinX team has been launching various
            projects in many areas. Our team consists of specialists in their
            field who are strong in mobile and web development, including DeFi.
          </p>
          <p className={styles.experienceText}>
            As for our latest DeFi projects, we have been working on NFT
            marketplace. The main goals were to attract users from new niches
            and allow them to take advantage of the NFT auction. The projects
            turned out to be easy to use, visually beautiful and useful for
            users.
          </p>
          <p className={styles.experienceText}>
            We want to present you in more details each project so that you
            could plunge into the atmosphere of the marketplaces and get
            inspired for your own project in which we can help you.
          </p>

          <ul className={styles.experienceList}>
            <li className={styles.experienceListItem}>
              <h4 className={styles.experienceListItemTitle}>
                Case 1: WeedWars
              </h4>
              <p className={styles.experienceListItemText}>
                WeedWars is an NFT Collection, DeFi module and future
                play-to-earn game based on fantasy characters leading an
                idealogical struggle in an alternate reality. Be an early
                adaptor and join the community because the story doesn&apos;t
                end here. You can stake your NFT&apos;s to get rewards in $WEED
                token which you can trade on cex/dex and in the future use it as
                an in-game currency.
              </p>
              <div className={styles.boxImage}>
                <div className={styles.boxImageStart}>
                  <Image
                    alt="weedwars.io site preview"
                    src={nftDecktopImage1}
                    placeholder="blur"
                    width={843}
                    height={2193}
                  />
                </div>
                <div className={styles.boxImageEnd}>
                  <Image
                    alt="weedwars.io mobile site preview"
                    src={nftMobileImage1}
                    placeholder="blur"
                    width={192}
                    height={2193}
                  />
                </div>
              </div>
            </li>

            <li className={styles.experienceListItem}>
              <h4 className={styles.experienceListItemTitle}>
                Case 2: PayRue NFT
              </h4>
              <p className={styles.experienceListItemText}>
                PayRue is a decentralized financial platform that allows to
                collect, buy and sell NFT assets. Here you will find different
                categories and collections of NFTs to any taste and color.
                Moreover, you can create your NFT right here! Everything that
                users are looking for on various marketplaces, they can find
                here, in one place.
              </p>
              <div className={styles.boxImage}>
                <div className={styles.boxImageStart}>
                  <Image
                    alt="payrue site preview"
                    src={nftDecktopImage2}
                    placeholder="blur"
                    width={843}
                    height={2709}
                  />
                </div>
                <div className={styles.boxImageEnd}>
                  <Image
                    alt="payrue mobile site preview"
                    src={nftMobileImage2}
                    placeholder="blur"
                    width={204}
                    height={2709}
                  />
                </div>
              </div>
            </li>

            <li className={styles.experienceListItem}>
              <h4 className={styles.experienceListItemTitle}>
                Case 3: NFT Wallet (Concept)
              </h4>
              <p className={styles.experienceListItemText}>
                After purchasing your NFT, it needs to be stored somewhere.
                Especially for this, we have created a concept in which NFT
                storage will be safe, and you will be satisfied and calm. It is
                important that NFT Wallet is done in the modern style, and the
                desired action can be completed in a couple of clicks without
                wasting your time. Everything is clear and beautiful here,
                don&apos;t you agree?
              </p>
              <div className={styles.multpleImage}>
                <div>
                  <Image
                    alt="NFT Wallet (Concept)"
                    src={multple1}
                    placeholder="blur"
                    width={331}
                    height={638}
                  />
                </div>
                <div>
                  <Image
                    alt="NFT Wallet (Concept)"
                    src={multple2}
                    placeholder="blur"
                    width={319}
                    height={638}
                  />
                </div>
                <div>
                  <Image
                    alt="NFT Wallet (Concept)"
                    src={multple3}
                    placeholder="blur"
                    width={274}
                    height={600}
                  />
                </div>
              </div>
            </li>

            <li className={styles.experienceListItem}>
              <h4 className={styles.experienceListItemTitle}>
                Case 4: Crypto Wallet (Concept)
              </h4>
              <p className={styles.experienceListItemText}>
                And of course, we couldn&apos;t forget about the crypto wallet.
                In this concept, you can see the unique style and design. The
                wallet allows users not only to store their coins, but also to
                track profit over periods, the dynamics of tokens and analyze a
                profitable deal. In this application, the user gets access to
                many features, thereby choosing it among other similar
                applications.
              </p>
              <div className={styles.multpleImage}>
                <Image
                  alt="Crypto Wallet (Concept)"
                  src={multple4}
                  placeholder="blur"
                  width={318}
                  height={596}
                />
                <Image
                  alt="Crypto Wallet (Concept)"
                  src={multple5}
                  placeholder="blur"
                  width={323}
                  height={593}
                />
                <Image
                  alt="Crypto Wallet (Concept)"
                  src={multple6}
                  placeholder="blur"
                  width={274}
                  height={594}
                />
              </div>
            </li>
          </ul>
        </div>
        <NFTDivided />
      </Container>
    </div>
  );
}
